import { useState, useEffect } from "react";
import API from "../lib/api";
import { X } from "lucide-react";

export default function BannerSlot({ page = "all" }) {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    API.get("/banners").then(r => {
      const filtered = r.data.banners.filter(b => b.page === page || b.page === "all");
      setBanners(filtered);
    }).catch(() => {});
  }, [page]);

  if (banners.length === 0) return null;

  return (
    <div className="space-y-2" data-testid={`banner-slot-${page}`}>
      {banners.map((banner) => (
        <div key={banner.banner_id} className="relative animate-banner-slide">
          <a href={banner.link || "#"} target="_blank" rel="noopener noreferrer"
            className="block rounded-xl overflow-hidden border border-[#2A3241]/40 hover:border-[#00F0FF]/30 transition-all">
            {banner.image_url ? (
              <img src={banner.image_url} alt={banner.title} className="w-full h-20 sm:h-24 object-cover" />
            ) : (
              <div className="w-full h-20 sm:h-24 bg-gradient-to-r from-[#131722] to-[#1C212E] flex items-center justify-center">
                <span className="text-sm text-[#94A3B8]">{banner.title || "Ad Space"}</span>
              </div>
            )}
          </a>
        </div>
      ))}
    </div>
  );
}
